import { IFilter } from "@/models/tables";
import { FilterOperators, FilterTypes } from "@/data/table";
import i18n from "@/i18n";

export const FirstNameFilter = (): IFilter => ({
  key: "firstname",
  label: i18n.t("_.first_name"),
  type: FilterTypes.STRING,
  operator: FilterOperators.CONTAINS
});

export const LastNameFilter = (): IFilter => ({
  key: "lastname",
  label: i18n.t("_.surname"),
  type: FilterTypes.STRING,
  operator: FilterOperators.CONTAINS
});

export const EmailFilter = (): IFilter => ({
  key: "email",
  label: i18n.t("_.email"),
  type: FilterTypes.STRING,
  operator: FilterOperators.CONTAINS
});

export const CreatedAtFilter = (): IFilter => ({
  key: "created_at",
  label: i18n.t("_.created"),
  type: FilterTypes.DATE,
  operator: FilterOperators.EQUAL
});

export const IPWhitelistFilter = (): IFilter => ({
  key: "ip_whitelist",
  label: i18n.t("_.ip_whitelist"),
  type: FilterTypes.SELECT_CHECKBOX,
  operator: FilterOperators.EQUAL,
  options: [
    { value: 0, label: i18n.t("_.inherit_brand_default") },
    { value: 1, label: i18n.t("_.none") },
    { value: 2, label: i18n.t("_.secure_with_whitelist_ips") }
  ]
});

export const WhitelistedIPsFilter = (): IFilter => ({
  key: "whitelisted_ips",
  label: i18n.t("_.whitelisted_ips"),
  type: FilterTypes.STRING,
  operator: FilterOperators.CONTAINS
});

export const DefaultUsersFilters = (): IFilter[] => [
  FirstNameFilter(),
  LastNameFilter(),
  EmailFilter(),
  IPWhitelistFilter(),
  WhitelistedIPsFilter(),
  CreatedAtFilter()
];

export const DefaultApiTokensFilters = (): IFilter[] => [
  IPWhitelistFilter(),
  WhitelistedIPsFilter(),
  CreatedAtFilter()
];
